// ReCaptchaProvider.js
import React, { createContext, Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {
  getNextJSServiceUrl,
  googleInvisibleCaptchaSiteKey,
} from "../config";

export const ReCaptchaContext = createContext();

class ReCaptchaProvider extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
  }

  executeRecaptcha = async () => {
    if (this.recaptchaRef.current) {
      const token = await this.recaptchaRef.current.executeAsync();
      this.recaptchaRef.current.reset(); // optional
      return token;
    }
    return null;
  };

  render() {
    const { children } = this.props;
    const siteKey = googleInvisibleCaptchaSiteKey();

    return (
      <ReCaptchaContext.Provider
        value={{ executeRecaptcha: this.executeRecaptcha }}
      >
        <ReCAPTCHA ref={this.recaptchaRef} size="invisible" sitekey={siteKey} />
        {children}
      </ReCaptchaContext.Provider>
    );
  }
}

export default ReCaptchaProvider;

export const captchaValidation = async (recaptchaContext) => {
  const { executeRecaptcha } = recaptchaContext;

  const token = await executeRecaptcha();
  if (!token) {
    this.setState({ loading: false, success: false });
    return false;
  }
  const response = await fetch(
    getNextJSServiceUrl() + `common/google-invisible-captcha`,
    {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.tokenId,
      },
      body: JSON.stringify({ token }),
    }   
  );
  const result = await response.json();
  return !!result.success ? result.success : false;
};
